import makeSlug from 'slugify'

const slug = (value: string) =>
  makeSlug(value, {
    remove: /[*+~.()'"!:@]/g,
    lower: true,
    strict: true,
  })

export const helpersSlug = {
  slugify: slug,
}
